// helpers.js

import {
  chatData,
  chatOpen,
  chatOpenType,
} from "../../../../Redux/Slices/messageSlice";

export const timeToMinutes = (time) => {
  if (!time) return null;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

export const isTimeValid = (start, end) => {
  if (!start || !end) return false;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return false;
  return eh > sh || (eh === sh && em > sm);
};

export const clearRowError = (
  errorsModalsArr = [],
  modalIndex,
  rowIndex,
  field,
) => {
  const next = errorsModalsArr.map((arr = []) =>
    arr.map((obj = {}) => ({ ...obj })),
  );
  if (next?.[modalIndex]?.[rowIndex]) {
    delete next[modalIndex][rowIndex][field];
  }
  return next;
};

export const clearFieldError = (errorsState, field) => ({
  ...errorsState,
  [field]: "",
});

export const toBackendTime = (time) => (time === "24:00" ? "00:00" : time);

export function isValidTime(start, end) {
  if (!start || !end) return false;
  const [startH, startM] = start.split(":").map(Number);
  const [endH, endM] = end.split(":").map(Number);
  if (isNaN(startH) || isNaN(startM) || isNaN(endH) || isNaN(endM))
    return false;
  return endH > startH || (endH === startH && endM > startM);
}

export function getConnectionId(activeName, elementName) {
  const activePrefix = activeName?.split("_")?.[0]?.charAt(0);
  const elementPrefix = elementName?.split("_")?.[0]?.charAt(0);

  // Check if one is Consumer (C) and other is Generator (G)
  const activeIsConsumer = activePrefix === "C";
  const elementIsConsumer = elementPrefix === "C";

  if (activeIsConsumer || elementIsConsumer) {
    // Standard case: C and G
    const consumerId = activeIsConsumer
      ? activeName?.split("_")?.[0]
      : elementName?.split("_")?.[0];
    const generatorId = activeIsConsumer
      ? elementName?.split("_")?.[0]
      : activeName?.split("_")?.[0];
    return `${consumerId}_${generatorId}`;
  }

  // Fallback: Sort alphabetically or numerically for consistent ordering
  const activeId = activeName?.split("_")?.[0];
  const elementId = elementName?.split("_")?.[0];

  // Sort to maintain consistent order (e.g., B164_B165)
  return activeId < elementId
    ? `${activeId}_${elementId}`
    : `${elementId}_${activeId}`;
}

export function openBilateralChat(
  dispatch,
  { header, fromUser, toUser, chatId, type, hidechat, tenderName },
) {
  const connectionId = getConnectionId(fromUser, toUser);
  dispatch(chatOpen(true));
  dispatch(chatOpenType(type || "BILATERAL"));
  dispatch(
    chatData({
      connectionId: chatId,
      header,
      fromUser,
      toUser,
      hidechat,
      tenderName,
    }),
  );
}
